import { LockIcon } from '../icons/LockIcon';
import { cn } from '../../lib/utils';

interface LockBadgeProps {
  className?: string;
  'data-testid'?: string;
}

/**
 * White circular lock badge for locked selected options — Figma 10203:54636.
 */
export function LockBadge({ className, 'data-testid': testId }: LockBadgeProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        'flex items-center justify-center rounded-xl border border-background bg-white p-1',
        className
      )}
    >
      <LockIcon className="size-3 text-background" />
    </span>
  );
}
